var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21s-.013-2.692 3.025-3.292c3.037-.6 3.225-1.35 3.225-1.95v-.75a5.325 5.325 0 01-1.5-2.625c-.938 0-1.5-1.125-1.5-2.25 0-.3 0-1.5.75-1.5-.6-2.4-.15-4.875 1.5-4.875 3.9-2.625 9.375-.562 7.5 4.875.75 0 .75 1.2.75 1.5 0 1.125-.563 2.25-1.5 2.25a5.288 5.288 0 01-1.5 2.625v.75c0 .6.188 1.35 3.225 1.95 3.525.713 3.525 3.3 3.525 3.3",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

export default SvgUser;